export default __webpack_public_path__ + "static/media/contactusv2.60ea11eb.png";